import { OrderedListOutlined } from '@ant-design/icons'
import { Flex } from 'antd'

import { useBlockType } from '../../hooks/useBlockType'
import { SHORTCUTS } from '../../plugins/ShortcutsPlugin/shortcuts'
import { MenuButton } from '../../ui/MenuButton'

import { NumberedListButtonProps } from './interface'

export const NumberedListButton = ({ iconSize }: NumberedListButtonProps) => {
  const [blockType, setBlockType] = useBlockType()

  return (
    <MenuButton
      actived={blockType === 'number'}
      tooltip={
        <Flex vertical align='center'>
          <span>有序列表</span>
          <span>{SHORTCUTS.NUMBERED_LIST}</span>
        </Flex>
      }
      onClick={() => {
        setBlockType({ type: 'number' })
      }}
    >
      <OrderedListOutlined style={{ fontSize: iconSize }} />
    </MenuButton>
  )
}
